export default __webpack_public_path__ + "static/media/CNo.41-0.a8807653.jpg";